const LaptopIcon = () => (
  <img src="/resources/images/laptop.png" alt="Laptop Icon" width={240} height={205} />
);

export default LaptopIcon;
